import RecoveryPin from './RecoveryPin';

export default RecoveryPin;
